import { c as _c } from "react/compiler-runtime";
import { Icon } from "@/components/ui/Icon";
import type { TextMessage } from "@/types/agent/message";
import { SpeechBubble } from "./SpeechBubble";
interface UserTextMessageProps {
  message: TextMessage;
}
export const UserTextMessage: React.FC<UserTextMessageProps> = t0 => {
  const $ = _c(9);
  const {
    message
  } = t0;
  let t1;
  if ($[0] !== message.attachment || $[1] !== message.content) {
    t1 = message.content && message.attachment && <hr className="my-2 border-white/20" />;
    $[0] = message.attachment;
    $[1] = message.content;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== message.attachment) {
    t2 = message.attachment && <div className="flex items-center gap-2 text-sm text-white/70"><Icon name="attachment" size={16} decorative={true} />{message.attachment}</div>;
    $[3] = message.attachment;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== message.content || $[6] !== t1 || $[7] !== t2) {
    t3 = <SpeechBubble sender="user">{message.content}{t1}{t2}</SpeechBubble>;
    $[5] = message.content;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};